module.exports = __webpack_public_path__ + "static/img/anli4.07c32b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anli4.jpg
// module id = VdNA
// module chunks = 1